import {createContext} from 'react';

import {ensighten} from 'shared/Ensighten/components';
import {EnsightenDataLayer, DataIDOptionalParams} from 'shared/Ensighten/types';

export const loadEnsighten = (url: string) => {
  const windowVars = window as any;
  try {
    if (!windowVars.Cypress) {
      //don't perform analytics in cypress tests
      const script = document.getElementById('ensighten-script');
      script?.setAttribute('src', url);
      if (window.location.hostname.includes('amplifyapp')) {
        //@ts-ignore
        window.targetGlobalSettings = {
          cookieDomain: window.location.hostname //https://experienceleague.adobe.com/en/docs/experience-manager-learn/sites/integrations/target/load-and-fire-target#why-are-my-mboxes-not-firing-on-my-web-pages%3F
        };
      }
    }
  } catch (e) {}
};

export enum ensightenPageTags {
  ACCOUNT_LANDING = 'Account Landing',
  AUTO_QUOTE_CUSTOMER = 'Auto quote customer information',
  AUTO_QUOTE_DRIVER = 'Auto quote driver information',
  AUTO_QUOTE_VEHICLE = 'Auto quote vehicle information',
  AUTO_QUOTE_DRIVING_HISTORY = 'Auto quote driving history information',
  AUTO_QUOTE_PRIOR_INSURANCE = 'Auto quote prior insurance information',
  AUTO_QUOTE_DISCOUNTS = 'Auto quote discount information',
  AUTO_QUOTE_SUMMARY = 'Auto quote summary',
  AUTO_QUOTE_KNOCKOUT_DRIVING_HISTORY = 'Knockout - Vehicle violation or offense',
  AUTO_QUOTE_KNOCKOUT_CURRENT_CUSTOMER = 'Knockout - Already a customer',
  AUTO_QUOTE_KNOCKOUT_NO_PRIOR_INSURANCE = 'Knockout - did not have active insurance',
  AUTO_QUOTE_KNOCKOUT_INCIDENT_LIMIT = 'Knockout - more than two accidents and/or violations',
  AUTO_QUOTE_KNOCKOUT_SDIP_LIMIT = 'SDIP is 08 or Higher - Knock out',
  AUTO_QUOTE_KNOCKOUT_MIN_YEARS_LICENSED = 'Knockout - Licensed less than 3 years',
  AUTO_QUOTE_KNOCKOUT_MIN_BI_LIMITS = 'Knockout - Bodily Injury limit',
  AUTO_QUOTE_KNOCKOUT_GREENLIGHT_RED = 'Knockout - GreenLight status Red',
  AUTO_QUOTE_KNOCKOUT_FACILITY_RISK = 'Knockout - Facility risk',
  MOTORCYCLE_QUOTE_CUSTOMER = 'Motorcycle quote customer information',
  MOTORCYCLE_QUOTE_RIDER = 'Motorcycle quote Rider information',
  MOTORCYCLE_QUOTE_VEHICLE = 'Motorcycle quote vehicle information',
  MOTORCYCLE_QUOTE_DRIVING_HISTORY = 'Motorcycle quote driving history information',
  MOTORCYCLE_QUOTE_PRIOR_INSURANCE = 'Motorcycle quote prior insurance information',
  MOTORCYCLE_QUOTE_DISCOUNTS = 'Motorcycle quote discount information',
  MOTORCYCLE_QUOTE_SUMMARY = 'Motorcycle quote summary',
  MOTORCYCLE_QUOTE_KNOCKOUT_VEHICLE_CLASS_TYPE = 'Knockout - Motorcycle class type of ',
  MOTORCYCLE_QUOTE_KNOCKOUT_CURRENT_CUSTOMER = 'Knockout - Already a motorcycle customer',
  DWELLING_QUOTE_KNOCKOUT_NUM_UNITS = 'Knockout - Number of units greater than 4',
  DWELLING_QUOTE_KNOCKOUT_RENTAL = 'Knockout - Rental property',
  DWELLING_QUOTE_KNOCKOUT_RETROFIT = 'Knockout - Retrofit',
  DWELLING_QUOTE_KNOCKOUT_NUM_CLAIMS = 'Knockout - Number of Home Loss Claims greater than 1',
  DWELLING_QUOTE_KNOCKOUT_PROTECTION_CLASS_CODE_MISSING = 'Knockout - Dwelling protection class code missing',
  AUTO_QUOTE_INTRODUCTORY_INFO = 'Auto quote Introductory Information',
  AUTO_QUOTE_ERROR = 'Knockout - API error',
  AUTO_QUOTE_ERROR_TIER_10 = 'Knockout - Tier 10 applicant',
  AUTO_QUOTE_ERROR_HAL_45 = 'Knockout - Hal of 45 or Higher',
  BIND_KNOCKOUT_SR22 = 'Knockout - Bind - SR22',
  BIND_KNOCKOUT_FOR_PROFIT_VEHICLE = 'Knockout - Bind - For Profit Vehicle',
  BIND_KNOCKOUT_GARAGED_LOCATION = 'Knockout - Bind - Garaged Location',
  BIND_KNOCKOUT_FOREIGN_LICENSE = 'Knockout - Bind - Foreign License',
  BIND_KNOCKOUT_REGISTERED_OWNER = 'Knockout - Bind - Registered Owner - other',
  BIND_KNOCKOUT_NO_CREDIT = 'Knockout - Bind - No credit results',
  BIND_KNOCKOUT_CANCELLED = 'Knockout - Bind - Cancelled',
  BIND_KNOCKOUT_NON_RENEWED = 'Knockout - Bind - Non-renewed',
  BIND_KNOCKOUT_BUSINESS_ON_PREMISES = 'Knockout - Bind - Business on premises',
  BIND_KNOCKOUT_FORECLOSURE_OR_BANK_OWNED = 'Knockout - Bind - Foreclosure or bank-owned',
  BIND_KNOCKOUT_NUMBER_OF_ROOMMATES_BOARDERS = 'Knockout - Bind - Number of roommates or boarders',
  BIND_KNOCKOUT_NO_FIRE_WALLS = 'Knockout - Bind - No fire walls',
  BIND_KNOCKOUT_TRAMPOLINE_ON_PREMISES = 'Knockout - Bind - Trampoline on premises',
  BIND_KNOCKOUT_FLOOD_INSURANCE_REQUIRED = 'Knockout - Bind - Flood insurance required',
  BIND_KNOCKOUT_ANIMALS = 'Knockout - Bind - Animals',
  BIND_KNOCKOUT_GREENLIGHT_RED = 'Knockout - Bind - GreenLight status Red',
  BIND_KNOCKOUT_GREENLIGHT_YELLOW = 'Knockout - Bind - GreenLight status Yellow',
  BIND_KNOCKOUT_FACILITY_RISK = 'Knockout - Bind - Facility risk',
  BIND_KNOCKOUT_CLUE_REPORT_INCIDENTS = 'Knockout - Bind - Clue Report Incidents',
  BIND_KNOCKOUT_WILDFIRE_RISK_BLOCKED_AMICA = 'Knockout- Bind - Wildfire risk - blocked Amica',
  BIND_KNOCKOUT_WILDFIRE_RISK_BLOCKED_WEB = 'Knockout - Bind - Wildfire risk - blocked Web',
  BIND_KNOCKOUT_DWELLING_OWNER = 'Knockout - Bind - Dwelling owner',
  BIND_KNOCKOUT_DWELLING_UNOCCUPIED = 'Knockout - Bind - Dwelling unoccupied',
  AUTO_QUOTE_BIND_ADDITIONAL_INFORMATION = 'Auto quote bind additional information',
  AUTO_QUOTE_BIND_POLICY_OWNERS = 'Auto quote bind finalize policy owners',
  AUTO_QUOTE_BIND_FINALIZE_DRIVERS = 'Auto quote bind finalize drivers',
  AUTO_QUOTE_BIND_FINALIZE_VEHICLES = 'Auto quote bind finalize vehicles',
  AUTO_QUOTE_BIND_CONFIRMATION = 'Auto quote bind confirmation',
  ONBOARDING_KNOCKOUT_ESIGN_DECLINE = 'Knockout - Onboarding - E-sign decline',
  RENTERS_QUOTE_BIND_ADDITIONAL_INFORMATION = 'Renters quote bind additional information',
  RENTERS_QUOTE_BIND_FINALIZE_TENANTS = 'Renters quote bind finalize renters',
  RENTERS_QUOTE_BIND_CONFIRMATION = 'Renters quote bind confirmation',
  CONDO_QUOTE_BIND_ADDITIONAL_INFORMATION = 'Condo quote bind additional information',
  CONDO_QUOTE_BIND_FINALIZE_HOMEOWNERS = 'Condo quote bind finalize homeowners',
  CONDO_QUOTE_BIND_MORTGAGE_INFORMATION = 'Condo quote bind mortgage information',
  CONDO_QUOTE_BIND_CONFIRMATION = 'Condo quote bind confirmation',
  HOME_QUOTE_SUMMARY = 'Home quote summary',
  HOME_QUOTE_ADDRESS_INFO = 'Home quote address information',
  HOME_QUOTE_CUSTOMER = 'Home quote customer information',
  HOME_QUOTE_INTRODUCTORY_INFO = 'Home quote introductory information',
  HOME_QUOTE_PROPERTY_INFO = 'Home quote property information',
  HOME_QUOTE_HOME_HISTORY = 'Home quote home history information',
  HOME_QUOTE_DISCOUNTS = 'Home quote discount information',
  HOME_QUOTE_PRIOR_INSURANCE = 'Home quote prior insurance information',
  PLATINUM_CHOICE_HOME_QUOTE_SUMMARY = 'Platinum choice home summary',
  PLATINUM_CHOICE_HOME_QUOTE_ADDRESS_INFO = 'Platinum choice home address information',
  PLATINUM_CHOICE_HOME_QUOTE_CUSTOMER = 'Platinum choice home customer information',
  PLATINUM_CHOICE_HOME_QUOTE_PROPERTY_INFO = 'Platinum choice home property information',
  PLATINUM_CHOICE_HOME_QUOTE_HOME_HISTORY = 'Platinum choice home history information',
  PLATINUM_CHOICE_HOME_QUOTE_DISCOUNTS = 'Platinum choice home discounts information',
  RENTERS_QUOTE_SUMMARY = 'Renters quote summary',
  RENTERS_QUOTE_ADDRESS_INFO = 'Renters quote address information',
  RENTERS_QUOTE_CUSTOMER = 'Renters quote customer information',
  RENTERS_QUOTE_INTRODUCTORY_INFO = 'Renters quote introductory information',
  RENTERS_QUOTE_PROPERTY_INFO = 'Renters quote property information',
  RENTERS_QUOTE_HOME_HISTORY = 'Renters quote home history information',
  RENTERS_QUOTE_DISCOUNTS = 'Renters quote discount information',
  RENTERS_QUOTE_PRIOR_INSURANCE = 'Renters quote prior insurance information',
  CONDO_QUOTE_SUMMARY = 'Condo quote summary',
  CONDO_QUOTE_ADDRESS_INFO = 'Condo quote address information',
  CONDO_QUOTE_CUSTOMER = 'Condo quote customer information',
  CONDO_QUOTE_INTRODUCTORY_INFO = 'Condo quote introductory information',
  CONDO_QUOTE_PROPERTY_INFO = 'Condo quote property information',
  CONDO_QUOTE_HOME_HISTORY = 'Condo quote home history information',
  CONDO_QUOTE_DISCOUNTS = 'Condo quote discount information',
  CONDO_QUOTE_PRIOR_INSURANCE = 'Condo quote prior insurance information',
  BUNDLE_QUOTE_CUSTOMER = 'Bundle quote customer information',
  BUNDLE_QUOTE_DRIVER = 'Bundle quote driver information',
  BUNDLE_QUOTE_DRIVING_HISTORY = 'Bundle quote driving history information',
  BUNDLE_QUOTE_DISCOUNTS = 'Bundle quote discount information',
  BUNDLE_QUOTE_PRIOR_INSURANCE = 'Bundle quote prior insurance information',
  BUNDLE_QUOTE_VEHICLE = 'Bundle quote vehicle information',
  BUNDLE_QUOTE_ADDRESS_INFO = 'Bundle quote address information',
  BUNDLE_QUOTE_PROPERTY_INFO = 'Bundle quote property information',
  BUNDLE_QUOTE_HOME_HISTORY = 'Bundle quote home history information',
  BUNDLE_QUOTE_SUMMARY = 'Bundle quote summary',
  RETURN_TO_QUOTE = 'Return to Quote Information',
  BILLING_AUTOPAY = 'Billing AutoPay',
  BILLING_OVERVIEW = 'Billing Overview',
  BILLING_AUTOPAY_COMPLETE = 'Complete',
  BILLING_AUTOPAY_CANCELED = 'Canceled',
  BILLING_MAKE_A_PAYMENT_SINGLE_PAYMENT = 'Make a Payment - Single Policy Payment',
  BILLING_MAKE_A_PAYMENT = 'Billing Make a Payment',
  BILLING_MAKE_A_PAYMENT_AMOUNT = 'Make a Payment - Pay All - Payment Amount',
  BILLING_MAKE_A_PAYMENT_PAYMENT_METHOD = 'Make a Payment - Payment Method',
  BILLING_MAKE_A_PAYMENT_VERIFICATION = 'Make a Payment - Verification',
  BILLING_MAKE_A_PAYMENT_ONE_INC_MODAL = 'One Inc Modal',
  BILLING_MAKE_A_PAYMENT_PAY_SINGLE_PAYMENT_AMOUNT = 'Make a Payment - Pay Single - Payment Amount',
  BILLING_MAKE_A_PAYMENT_PAYMENT_CANCELED = 'Payment Canceled',
  BILLING_MAKE_A_PAYMENT_PAYMENT_COMPLETE = 'Payment Complete',
  BILLING_MAKE_A_PAYMENT_SCHEDULED_PAYMENT = 'Payment Scheduled',
  BILLING_MAKE_A_PAYMENT_PAYMENT_METHOD_SAVED = 'Payment Method Saved',
  BILLING_MAKE_A_PAYMENT_QUICK_PAY_PAYMENT_AMOUNT = 'Make a Payment - Quick Pay - Payment Amount',
  BILLING_ONE_INC_ERROR = 'Error',
  BILLING_ONE_INC_MODAL_DIALOG_OPENED = 'Modal Loaded',
  BILLING_ONE_INC_MODAL_ERROR = 'Modal Error',
  BILLING_ONE_INC_MODAL_LOADING = 'Modal Load',
  BILLING_ONE_INC_MODAL_UNLOAD = 'Modal Unload',
  BILLING_TRANSACTIONS = 'Billing Transactions',
  BILLING_CHANGE_PAYMENT_PLAN_SELECTION = 'Change Payment Plan - Payment Plan Selection',
  BILLING_CHANGE_PAYMENT_PLAN_REVIEW = 'Change Payment Plan - Review Selected Plan',
  BILLING_CHANGE_PAYMENT_PLAN_CONFIRMATION = 'Change Payment Plan - Confirmation',
  CLAIMS_COVERAGES_AND_PAYMENTS = 'Claims - Coverages and Payments',
  CLAIMS_DOCUMENTS = 'Claims - Documents',
  CLAIMS_LANDING = 'Claims Landing',
  CLAIMS_MESSENGER = 'Claims - Messenger',
  CLAIMS_OVERVIEW = 'Claims - Overview',
  CLAIMS_SETTINGS = 'Claims - Settings',
  DOCUMENTS_LANDING = 'Documents - Landing',
  DOCUMENTS_UPLOAD_LANDING_POLICY = 'Documents - Upload Landing - Policy',
  DOCUMENTS_UPLOAD_LANDING_CLAIM = 'Documents - Upload Landing - Claim',
  DOCUMENTS_UPLOAD_STEP1_POLICY = 'Documents - Upload Step 1 - Policy',
  DOCUMENTS_UPLOAD_STEP1_CLAIM = 'Documents - Upload Step 1 - Claim',
  DOCUMENTS_UPLOAD_STEP2_POLICY = 'Documents - Upload Step 2 - Policy',
  DOCUMENTS_UPLOAD_STEP2_CLAIM = 'Documents - Upload Step 2 - Claim',
  DOCUMENTS_UPLOAD_STEP3_POLICY_SUCCESSFUL = 'Documents - Upload Step 3 - Policy - Successful',
  DOCUMENTS_UPLOAD_STEP3_POLICY_PARTIAL_SUCCESS = 'Documents - Upload Step 3 - Policy - Partial Success',
  DOCUMENTS_UPLOAD_STEP3_POLICY_UNSUCCESSFUL = 'Documents - Upload Step 3 - Policy - Unsuccessful',
  DOCUMENTS_UPLOAD_STEP3_CLAIM_SUCCESSFUL = 'Documents - Upload Step 3 - Claim - Successful',
  DOCUMENTS_UPLOAD_STEP3_CLAIM_PARTIAL_SUCCESS = 'Documents - Upload Step 3 - Claim - Partial Success',
  DOCUMENTS_UPLOAD_STEP3_CLAIM_UNSUCCESSFUL = 'Documents - Upload Step 3 - Claim - Unsuccessful',
  DOCUMENTS_EMBEDDED_ESIGN = 'Documents - Embedded Esign',
  DOCUMENTS_PRELOGIN_UPLOAD_STEP1 = 'Pre Login Doc Upload - Claim Information',
  DOCUMENTS_PRELOGIN_UPLOAD_STEP2 = 'Pre Login Doc Upload - Contact Information',
  DOCUMENTS_PRELOGIN_UPLOAD_STEP3 = 'Pre Login Doc Upload - Document Upload',
  DOCUMENTS_PRELOGIN_UPLOAD_STEP4 = 'Pre Login Doc Upload - Confirmation',
  DOCUMENTS_PRELOGIN_UPLOAD_SYSTEM_OUTAGE = 'Pre Login Doc Upload - System Outage Error',
  EXPRESS_ID_CARDS = 'Express ID Cards',
  EXPRESS_PAYMENT_SELECT_LOB = 'Express Payment - LOB Selection',
  EXPRESS_PAYMENT_MUTUAL_ACCOUNT_VALIDATION = 'Express Payment - Mutual Account Validation',
  EXPRESS_PAYMENT_LIFE_POLICY_VALIDATION = 'Express Payment - Life Policy Validation',
  EXPRESS_PAYMENT_PAYMENT_CONFIRMATION = 'Express Payment - Payment Confirmation',
  EXPRESS_PAYMENT_CONTACT_INFORMATION = 'Express Payment - Contact Information',
  EXPRESS_PAYMENT_PAYMENT_METHOD = 'Express Payment - Payment Information',
  EXPRESS_PAYMENT_PAYMENT_REVIEW = 'Express Payment - Payment Review',
  EXPRESS_PAYMENT_PAYMENT_SELECTION = 'Express Payment - Payment Selection',
  EXPRESS_PAYMENT_ONE_INC_MODAL = 'Express Payment - One Inc Modal',
  HOMEOWNER_PHOTO_TOOL_ADDITIONAL_DETAILS = 'Photo Tool - Additional Details',
  HOMEOWNER_PHOTO_TOOL_CLAIM_CLOSED = 'Photo Tool - Expired Claim',
  HOMEOWNER_PHOTO_TOOL_FINISH = 'Photo Tool - Confirmation',
  HOMEOWNER_PHOTO_TOOL_INTRO = 'Photo Tool - Landing',
  HOMEOWNER_PHOTO_TOOL_UPLOAD = 'Photo Tool - Photo Upload',
  ID_CARDS = 'ID Cards Landing',
  LOGIN = 'Login',
  LOGIN_SYSTEM_TIME_ERROR = 'Login - System Time Error',
  LOGIN_UNSUPPORTED_BROWSER_ERROR = 'Login - Unsupported Browser Error',
  LOGIN_ERROR = 'Login Error',
  CREATE_ACCOUNT_QUESTIONS = 'Create Account - Information',
  CREATE_ACCOUNT_VERIFICATION = 'Create Account - Verification',
  CREATE_ACCOUNT_CONFIRMATION = 'Create Account - Validation',
  CREATE_ACCOUNT_LOGIN_ID = 'Create Account - Login ID',
  CREATE_ACCOUNT_CHOOSE_PASSWORD = 'Create Account - Create Password',
  CREATE_ACCOUNT_SUCCESS = 'Create Account - Confirmation',
  POLICIES_DETAIL_COVERAGES = 'Policy - Coverages',
  POLICIES_DETAIL_DISCOUNTS = 'Policy - Discounts',
  POLICIES_DETAIL_ID_CARDS = 'Policy - ID Cards',
  POLICIES_DETAIL_LIFE_OVERVIEW = 'Policy - Overview',
  POLICIES_DETAIL_MUTUAL_OVERVIEW = 'Policy - Overview',
  POLICIES_LANDING = 'Policies Landing',
  POLICIES_LANDING_ACTIVE = 'Policies Active',
  POLICIES_LANDING_ARCHIVED = 'Policies Archived',
  POLICIES_ADD_VEHICLE_COVERAGE_DETAILS = 'Policy - Add vehicle coverage details',
  POLICIES_ADD_VEHICLE_COVERAGE_REVIEW = 'Policy - Add vehicle coverage review',
  POLICIES_ADD_VEHICLE_DETAILS = 'Policy - Add vehicle details',
  POLICIES_ADD_VEHICLE_KNOCKOUT = 'Policy - Add vehicle Knockout questions',
  POLICIES_EDIT_COVERAGES_CONFIRMATION = 'Policy - Edit vehicle coverage confirmation',
  POLICIES_EDIT_COVERAGES_DETAILS = 'Policy - Edit vehicle coverage details',
  POLICIES_EDIT_COVERAGES_REVIEW = 'Policy - Edit vehicle coverage review',
  POLICIES_EDIT_DEDUCTIBLE = 'Policies - Edit Home Coverages - Edit Deductible',
  POLICIES_EDIT_DEDUCTIBLE_VERIFY = 'Policies - Edit Home Coverages - Verify Changes',
  POLICIES_EDIT_DEDUCTIBLE_CONFIRMATION = 'Policies - Edit Home Coverages - Confirmation',
  POLICIES_EDIT_LENDER_CONFIRMATION_ADD = 'Home Lender - Add Lender Confirmation',
  POLICIES_EDIT_LENDER_CONFIRMATION_REPLACE = 'Home Lender - Replace Lender Confirmation',
  POLICIES_EDIT_LENDER_CONFIRMATION_REMOVE = 'Home Lender - Remove Lender Confirmation',
  POLICIES_EDIT_LENDER_REVIEW_ADD = 'Home Lender - Add Lender Review',
  POLICIES_EDIT_LENDER_REVIEW_REPLACE = 'Home Lender - Replace Lender Review',
  POLICIES_EDIT_LENDER_REVIEW_REMOVE = 'Home Lender - Remove Lender Review',
  POLICIES_EDIT_LENDER_UPDATE_LENDER = 'Home Lender - Update Lender',
  POLICIES_EDIT_LENDER_SELECT_LENDER = 'Home Lender - Select Lender',
  POLICIES_EDIT_LENDER_WELCOME_LENDER = 'Home Lender - Lender Welcome Page',
  POLICIES_EDIT_LENDER_LENDER_DETAILS = 'Home Lender - Lender Details',
  POLICIES_EDIT_LENDER_ESCROW_DETAILS = 'Home Lender - Escrow Details',
  POLICIES_UPDATE_LENDER_SELECT = 'Policies - Remove Lender - Select Lender',
  POLICIES_UPDATE_LENDER_VERIFY = 'Policies - Remove Lender - Verify',
  POLICIES_UPDATE_LENDER_CONFIRMATION = 'Policies - Remove Lender - Confirmation',
  POLICIES_ESTIMATE_DRIVER_INFORMATION = 'Policies - Estimate Driver - Driver Info',
  POLICIES_ESTIMATE_DRIVER_AVAILABLE_DRIVERS = 'Policies - Estimate Driver - Re-Estimate Previous',
  POLICIES_ESTIMATE_DRIVER_VEHICLE_DRIVER_PERCENTAGES = 'Policies - Estimate Driver - Vehicle Driver Percentages',
  POLICIES_ESTIMATE_DRIVER_PRINCIPAL_OPERATOR = 'Policies - Estimate Driver - Assign Principal Operator',
  POLICIES_ESTIMATE_DRIVER_DISCOUNTS = 'Policies - Estimate Driver - Driver Discounts',
  POLICIES_ESTIMATE_DRIVER_REVIEW = 'Policies - Estimate Driver - Review',
  POLICIES_ESTIMATE_VEHICLE_COVERAGE_DETAILS = 'Policy - Estimate new vehicle coverage details',
  POLICIES_ESTIMATE_VEHICLE_DETAILS = 'Policy - Estimate new vehicle details',
  POLICIES_ESTIMATE_VEHICLE_KNOCKOUT = 'Policy - Estimate new vehicle Knockout qst',
  POLICIES_REMOVE_VEHICLE_CONFIRMATION = 'Remove Vehicle - Confirmation',
  POLICIES_REMOVE_VEHICLE_COVERAGE_DETAILS = 'Remove Vehicle - Edit Coverages',
  POLICIES_REMOVE_VEHICLE_SELECT_A_VEHICLE = 'Remove Vehicle - Select a Vehicle',
  POLICIES_REMOVE_VEHICLE_SELECT_REMOVE_OR_REPLACE = 'Remove Vehicle - Remove or Replace Vehicle',
  POLICIES_REMOVE_VEHICLE_KNOCKOUT_QUESTIONS = 'Remove Vehicle - Knockout Questions',
  POLICIES_REMOVE_VEHICLE_PLATE_SURRENDERED_DATE = 'Remove Vehicle - Plate Surrendered Date',
  POLICIES_REMOVE_VEHICLE_SELECT_PRIMARY_VEHICLE = 'Remove Vehicle - Select a Primary Vehicle',
  POLICIES_REMOVE_VEHICLE_REVIEW = 'Remove Vehicle - Review Changes',
  POLICIES_QUOTE_ADD_VEHICLE_KNOCKOUT_QUESTIONS = 'Policy - Quote Vehicle - Knockout Questions',
  POLICIES_QUOTE_ADD_VEHICLE_INTRODUCTION = 'Policy - Quote Vehicle - Information Page',
  POLICIES_QUOTE_ADD_VEHICLE_REPLACE_EXISTING_VEHICLE = 'Policy - Quote Vehicle - Replace Existing Vehicle',
  POLICIES_QUOTE_ADD_VEHICLE_VEHICLE_DETAILS = 'Policy - Quote Vehicle - Vehicle Details',
  POLICIES_QUOTE_ADD_VEHICLE_PURCHASE_DETAILS = 'Policy - Quote Vehicle - Purchase Details',
  POLICIES_QUOTE_ADD_VEHICLE_VEHICLE_USAGE_DETAILS = 'Policy - Quote Vehicle - Vehicle Usage Details',
  POLICIES_QUOTE_ADD_VEHICLE_ADDITIONAL_VEHICLE_DETAILS = 'Policy - Quote Vehicle - Additional Vehicle Details',
  POLICIES_QUOTE_ADD_VEHICLE_EDIT_VEHICLE_COVERAGES = 'Policy - Quote Vehicle - Edit Vehicle Coverages',
  POLICIES_QUOTE_ADD_VEHICLE_FINALIZE_VEHICLE_DETAILS = 'Policy - Quote Vehicle - Finalize Vehicle Details',
  POLICIES_QUOTE_ADD_VEHICLE_LENDER_DETAILS = 'Policy - Quote Vehicle - Lender Details',
  POLICIES_QUOTE_ADD_VEHICLE_REVIEW = 'Policy - Quote Vehicle - Review',
  POLICIES_QUOTE_ADD_VEHICLE_CONFIRMATION = 'Policy - Quote Vehicle - Confirmation',
  PROFILE_CONTACT_INFORMATION = 'Profile - Contact Info',
  PROFILE_EPROXY = 'Profile - E-Proxy',
  PROFILE_FORCED_LOGOUT = 'Profile - Logged out',
  PROFILE_PAYMENT_METHODS = 'Profile - Payment Methods',
  PROFILE_PASSWORD = 'Profile - Password',
  PROFILE_MFA = 'Profile - MFA',
  PROFILE_PAPERLESS_PREFERENCES = 'Profile - Paperless',
  PROFILE_PAPERLESS_PREFERENCES_MANAGE_EPOLICY = 'Profile - Paperless - Manage Epolicy',
  PROFILE_PAPERLESS_PREFERENCES_MANAGE_EBILL = 'Profile - Paperless - Manage Ebill',
  PROFILE_PAPERLESS_PREFERENCES_MANAGE_LIFE = 'Profile - Paperless - Manage Elife',
  PROFILE_TEXTING = 'Profile - Texting',
  PROFILE_TEXTING_ENROLL = 'Profile - Texting Enroll',
  PROFILE_UPDATE_LIFE_ADDRESS = 'Profile - Update Life Address',
  PROFILE_MANAGE_EMAIL = 'Profile - Manage Email',
  PROFILE_ADD_EMAIL = 'Profile - Add Email',
  PROFILE_MANAGE_PHONE = 'Profile - Manage Phone',
  PROFILE_ADD_PHONE = 'Profile - Add Phone',
  FNOL_ADDITIONAL_INFO = 'Additional Information',
  FNOL_AUTO_DAMAGE_DESCRIPTION = 'Claim Description',
  FNOL_AUTO_GLASS_DAMAGE_LOCATIONS = 'Report a Claim - Where is the glass damage located?',
  FNOL_AUTO_GLASS_INCIDENT_TYPE = 'Report a Claim - What caused the glass damage?',
  FNOL_AUTO_GLASS_VENDOR = 'Report a Claim - Glass Safelite',
  FNOL_AUTO_LOSS_DESCRIPTION = 'Report a Claim - Claim Type',
  FNOL_CONTACT_INFORMATION = 'Report a Claim - Contact Information',
  FNOL_HOME_LOSS_DESCRIPTION = 'Report a Claim - Claim Type',
  FNOL_HOME_LOSS_NOT_WEATHER_RELATED = 'Report a Claim - Claim Description',
  FNOL_HOME_LOSS_WEATHER_RELATED = 'Report a Claim - What Weather Damage',
  FNOL_INTRO = 'Report a Claim - Intro',
  FNOL_LOSS_DATE = 'Report a Claim - Date Time',
  FNOL_LOSS_LOCATION = 'Report a Claim - Claim Location',
  FNOL_OTHER_VEHICLE = 'Report a Claim - Who Owns the Vehicle',
  FNOL_SELECT_POLICY = 'Report a Claim - Select Policy',
  FNOL_TEXT_NOTIFICATION = 'Report a Claim - Text Notification Enrollment',
  FNOL_TOW_AMOUNT = 'Report a Claim - Tow Cost',
  FNOL_VEHICLE_LOCATION = 'Report a Claim - Vehicle Location Now',
  FNOL_ANYONE_INJURED = 'Report a Claim - Was Anyone Injured',
  FNOL_VEHICLE_DAMAGED = 'Report a Claim - Was Vehicle Damaged',
  FNOL_VEHICLE_RECOVERED = 'Report a Claim - Was Vehicle Recovered',
  FNOL_WEATHER_RELATED = 'Report a Claim - Was Weather Related',
  FNOL_WHO_WAS_DRIVING = 'Report a Claim - Auto Driver',
  FNOL_SUMMARY = 'Report a Claim - Summary',
  FNOL_CONFIRMATION = 'Report a Claim - Confirmation',
  FNOL_PRELOGIN_INTRO_PAGE = 'Pre Login FNOL - Intro Page',
  FNOL_PRELOGIN_SELECT_POLICY = 'Pre Login FNOL - Type of Loss',
  FNOL_PRELOGIN_WHO_IS_FILING = 'Pre Login FNOL - Who is Filing',
  FNOL_PRELOGIN_HOME_INCIDENT_DETAILS = 'Pre Login FNOL - Home Incident Details',
  FNOL_PRELOGIN_POLICY_DETAILS = 'Pre Login FNOL - Policy Details (Customer)',
  FNOL_PRELOGIN_POLICY_DETAILS_GUEST = 'Pre Login FNOL - Policy Details (Guest)',
  FNOL_PRELOGIN_POLICY_DETAILS_LIFE = 'Pre Login FNOL - Life Policy Details (Customer)',
  FNOL_PRELOGIN_POLICY_DETAILS_LIFE_GUEST = 'Pre Login FNOL - Life Policy Details (Guest)',
  FNOL_PRELOGIN_AUTO_INCIDENT_DETAILS = 'Pre Login FNOL - Auto Incident Details',
  FNOL_PRELOGIN_MARINE_INCIDENT_DETAILS = 'Pre Login FNOL - Marine Incident Details',
  FNOL_PRELOGIN_GLASS_DAMAGE = 'Pre Login FNOL - Glass Damage',
  FNOL_PRELOGIN_WEATHER_RELATED = 'Pre Login FNOL - Was Weather Related',
  FNOL_PRELOGIN_AUTO_VEHICLE_INFO = 'Pre Login FNOL - Auto Vehicle Info',
  FNOL_PRELOGIN_MARINE_VESSEL_INFO = 'Pre Login FNOL - Marine Vessel Info',
  FNOL_PRELOGIN_WEATHER_RELATED_DAMAGE = 'Pre Login FNOL - Weather Related Damage',
  FNOL_PRELOGIN_NOT_WEATHER_RELATED_DAMAGE = 'Pre Login FNOL - Not Weather Related',
  FNOL_PRELOGIN_INCIDENT_DATE_TIME = 'Page Name: Pre Login FNOL - Date Time',
  FNOL_PRELOGIN_ADDITIONAL_DETAILS_DISABILITY = 'Pre Login FNOL - Life Disability Incident Details',
  FNOL_PRELOGIN_ADDITIONAL_DETAILS_AUTO = 'Pre Login FNOL - Auto Additional Info',
  FNOL_PRELOGIN_ADDITIONAL_DETAILS_MARINE = 'Pre Login FNOL - Marine Additional Info',
  FNOL_PRELOGIN_ADDITIONAL_DETAILS_HOME = 'Pre Login FNOL - Home Additional Info',
  FNOL_PRELOGIN_ADDITIONAL_DETAILS_DEATH = 'Pre Login FNOL - Life Death Incident Details',
  FNOL_PRELOGIN_INCIDENT_LOCATION = 'Pre Login FNOL - Incident Location',
  FNOL_PRELOGIN_WHO_IS_REPORTING = 'Pre Login FNOL - Who is Reporting',
  FNOL_PRELOGIN_MUTUAL_CONTACT_INFO = 'Pre Login FNOL - Contact Info',
  FNOL_PRELOGIN_LIFE_CONTACT_INFO = 'Pre Login FNOL - Life Contact Info',
  FNOL_PRELOGIN_AUTO_SUMMARY = 'Pre Login FNOL - Auto Summary',
  FNOL_PRELOGIN_HOME_SUMMARY = 'Pre Login FNOL - Home Summary',
  FNOL_PRELOGIN_MARINE_SUMMARY = 'Pre Login FNOL - Marine Summary',
  FNOL_PRELOGIN_DISABILITY_SUMMARY = 'Pre Login FNOL - Disability Summary',
  FNOL_PRELOGIN_DEATH_SUMMARY = 'Pre Login FNOL - Death Summary',
  FNOL_PRELOGIN_MUTUAL_CONFIRMATION = 'Pre Login FNOL - Confirmation',
  FNOL_PRELOGIN_DEATH_CONFIRMATION = 'Pre Login FNOL - Death Confirmation',
  FNOL_PRELOGIN_DISABILITY_CONFIRMATION = 'Pre Login FNOL - Disability Confirmation',
  FNOL_PRELOGIN_ERROR = 'Pre Login FNOL - Error',
  ONBOARDING_INTRO = 'Onboarding - Intro',
  ONBOARDING_ESIGN = 'Onboarding - E-Sign',
  ONBOARDING_PAYMENT = 'Onboarding - Payment',
  ONBOARDING_CONFIRM = 'Onboarding - Payment Confirmation',
  ONBOARDING_WELCOME = 'Onboarding - Welcome',
  ONBOARDING_ERROR = 'Onboarding - Error Page',
  ONBOARDING_KNOCKOUT = 'Onboarding - Knockout Page',
  ONBOARDING_MANAGE_EPOLICY = 'Onboarding - Manage Epolicy',
  ONBOARDING_MANAGE_EBILL = 'Onboarding - Manage Ebill',
  ONBOARDING_HOME = 'Onboarding - Home',
  MOBILE_APP_INFO = 'Amica Mobile App Info',
  LIFE_QUOTE_INPUTS = 'Life Quote Inputs',
  LIFE_QUOTE_SUMMARY = 'Life Quote Summary',
  LIFE_QUOTE_KNOCKOUT = 'Life Quote Knockout',
  LIFE_QUOTE_KNOCKOUT_HW_01 = 'Life Quote Knockout - Height or Weight out of range',
  LIFE_QUOTE_KNOCKOUT_HA_01 = 'Life Quote Knockout - Health Assessment out of range',
  LIFE_QUOTE_KNOCKOUT_CA_01 = 'Life Quote Knockout - Coverage amount missing',
  LIFE_QUOTE_KNOCKOUT_CA_02 = 'Life Quote Knockout - Coverage amount too high',
  LIFE_QUOTE_KNOCKOUT_CA_03 = 'Life Quote Knockout - Coverage amount too low',
  LIFE_QUOTE_KNOCKOUT_AG_01 = 'Life Quote Knockout - Age invalid',
  LIFE_QUOTE_KNOCKOUT_TU_01 = 'Life Quote Knockout - Tobacco usage missing',
  LIFE_QUOTE_KNOCKOUT_SE_01 = 'Life Quote Knockout - Sex missing',
  LIFE_QUOTE_KNOCKOUT_DOB_01 = 'Life Quote Knockout - Date of birth missing',
  LIFE_QUOTE_KNOCKOUT_ST_01 = 'Life Quote Knockout - State missing',
  LIFE_QUOTE_KNOCKOUT_WT_01 = 'Life Quote Knockout - Weight missing',
  LIFE_QUOTE_KNOCKOUT_HT_01 = 'Life Quote Knockout - Height missing',
  LIFE_QUOTE_KNOCKOUT_LN_01 = 'Life Quote Knockout - Last name missing',
  LIFE_QUOTE_KNOCKOUT_TL_01 = 'Life Quote Knockout - No term lengths available',
  LIFE_QUOTE_KNOCKOUT_AS_01 = 'Life Quote Knockout - Application already started',
  LIFE_QUOTE_KNOCKOUT_API_ERROR = 'Life Quote Knockout - API error'
}

export enum ensightenPromoTags {
  ACCOUNT_PAPERLESS = 'Account Paperless',
  LIFE_PAPERLESS = 'Life Paperless',
  CROSS_SELL = 'Cross Sell',
  CROSS_SELL_PAYMENT_NORTHEAST_TARGET = 'Cross Sell Payment Northeast',
  HO5_PROMO = 'HO5 Promo',
  HOME_PIF_CALL = 'Home PIF Call',
  HOME_PIF_CHANGE_PAYMENT_PLAN = 'Home PIF Change Payment Plan',
  PIF_CHANGE_PAYMENT_PLAN = 'PIF Change Payment Plan',
  PIF_BILLING_OVERVIEW = 'PIF Billing Overview',
  PIF_CALL = 'PIF CALL',
  STREETSMART = 'StreetSmart',
  ANNUITIES = 'MYGA Annuities',
  MOBILE_APP = 'Mobile App',
  SEMI_ANNUAL_PAYMENT = 'Semi-Annual Payment',
  SMARTER_HOME = 'Smarter Home',
  TERM_LIFE = 'Term Life'
}

export interface PageDataTemplate {
  category: string;
}

interface PageDataTemplates {
  [key: string]: PageDataTemplate;
}

export interface NamedPageDataTemplate extends PageDataTemplate {
  name: string;
}

export const pageDataTemplates: PageDataTemplates = {
  account: {
    category: 'Profile'
  },
  billing: {
    category: 'Billing'
  },
  claims: {
    category: 'Claims'
  },
  documents: {
    category: 'Documents'
  },
  documentsPrelogin: {
    category: 'Pre Login Docs'
  },
  fnol: {
    category: 'FNOL'
  },
  fnolPrelogin: {
    category: 'Pre Login FNOL'
  },
  accountLanding: {
    category: 'Account'
  },
  idCards: {
    category: 'ID Cards'
  },
  photoTool: {
    category: 'Photo Tool'
  },
  policies: {
    category: 'Policies'
  },
  express: {
    category: 'Express Services'
  },
  login: {
    category: 'Login'
  },
  createAccount: {
    category: 'Create Account'
  },
  autoQuote: {
    category: 'Auto quote'
  },
  motorcycleQuote: {
    category: 'Motorcycle quote'
  },
  homeQuote: {
    category: 'Home quote'
  },
  rentersQuote: {
    category: 'Renters quote'
  },
  condoQuote: {
    category: 'Condo quote'
  },
  autohomeQuote: {
    category: 'Auto and Home bundle quote'
  },
  autorentersQuote: {
    category: 'Auto and Renters bundle quote'
  },
  autocondoQuote: {
    category: 'Auto and Condo bundle quote'
  },
  returnToQuote: {
    category: 'Return to quote'
  },
  onboarding: {
    category: 'Onboarding'
  },
  mobileAppInfo: {
    category: 'Mobile App Info'
  },
  lifeQuote: {
    category: 'Life quote'
  }
};

export function getInitialState(): EnsightenDataLayer {
  return {
    global: {
      pageCategory: 'homePage',
      pageName: 'homePage',
      resolution: `${window.screen.availWidth}x${window.screen.availHeight}`,
      device: window.navigator.userAgent,
      timeStamp: +new Date()
    },
    message: {
      messageID: '',
      messageType: '',
      messageDescription: ''
    },
    log: {logInfo: ''},

    quote: {
      quoteId: '',
      jobNumber: '',
      quoteLOB: '',
      state: '',
      sourceOfBusiness: '',
      numberOfDrivers: 0,
      numberOfVehicles: 0,
      numberOfIncidents: 0,
      autoSegmentation: '',
      dwellingSegmentation: '',
      errorCodes: [],
      allowBind: [],
      quotingEmail: '',
      quotingPhonenumber: '',
      easOfferings: undefined
    },
    policy: {
      policyNumber: '',
      policies: []
    },
    claims: {
      claimFileNumber: '',
      claimsLOB: '',
      claimsType: '',
      claimStatus: '',
      emailStatus: ''
    },
    billing: {
      billingLOB: '',
      billingCurrentPaymentPlan: '',
      billingSelectedPaymentPlan: ''
    },
    profile: {
      accounts: [],
      username: '',
      age: 0,
      email: '',
      partyUID: '',
      paperlessEBill: false,
      paperlessEPolicy: false
    },
    abTests: {activeTests: []}
  };
}

// If there is a section (such as the header or footer) that should not change as the page
// changes, you can add add a `<PageNameOverrideContext.Provider value="PAGE_NAME">`
// tag wrapping the parent component, to override the pageName part of the data-id generation.
export const PageNameOverrideContext = createContext('');

/**
 * getDataID function generates data-id attribute that's picked up by ensighten
 * @param name The base name used for the data-id
 * @param spreadOfProps Takes the spread of the given components props, from which the optional params are distilled
 * @param pageNameOverride The page name override context if applicable
 */

export const getDataID = (name: string, spreadOfProps: any, pageNameOverride?: string) => {
  const prefix = pageNameOverride || ensighten.dataLayer.global.pageName;
  if (!spreadOfProps) {
    return `${prefix}.${name}`.replace(/ /g, '-');
  }
  const {value, analyticsSection, type, indexNumber, $hasDataIDOverRide}: DataIDOptionalParams = spreadOfProps;
  if (!$hasDataIDOverRide && (type === 'radio' || type === 'checkbox')) {
    return `${prefix}.${name}.${value}`.replace(/ /g, '-');
  }
  return typeof indexNumber !== 'undefined'
    ? `${prefix}.${name}${analyticsSection ? `-${analyticsSection}` : ''}-${indexNumber}`.replace(/ /g, '-')
    : `${prefix}.${name}`.replace(/ /g, '-');
};
